import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Contact = () => {

    useEffect(() => {
        document.title = 'StoneSkill | Contact'
    })

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        telephone: '',
        subject: '',
        message: '',
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "name") {
            const onlyLetters = value.replace(/[^a-zA-Z\s]/g, '');
            setFormData((prev) => ({ ...prev, [name]: onlyLetters }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }

        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
        }
    };



    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        if (!formData.name.trim()) newErrors.name = 'First Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Email is not valid';
        }

        if (!formData.telephone.trim()) {
            newErrors.telephone = 'Phone number is required';
        } else if (!phoneRegex.test(formData.telephone)) {
            newErrors.telephone = 'Phone number must be exactly 10 digits';
        }

        if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
        if (!formData.message.trim()) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            console.log('Form submitted successfully:', formData);
        } else {
            console.log('Validation failed');
        }
    };



    return (
        <>
            <div>
                <main className="main pages">
                    <div className="page-header breadcrumb-wrap">
                        <div className="container">
                            <div className="breadcrumb">
                                <Link to={'/'} rel="nofollow">
                                    <i className="fi-rs-home mr-5" />
                                    Home
                                </Link>
                                <span /> Pages <span /> Contact
                            </div>
                        </div>
                    </div>
                    <div className="page-content pt-50">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-10 col-lg-12 m-auto">
                                    <section className="row align-items-end mb-50">
                                        <div className="col-lg-4 mb-lg-0 mb-md-5 mb-sm-5">
                                            <h4 className="mb-20 text-brand">How we can help you ?</h4>
                                            <h1 className="mb-30">Let us know how we can help you</h1>
                                            <p className="mb-20">At StoneSkill, we provide expert guidance, professional services, and tailored solutions to meet your needs with quality, efficiency, and reliability.</p>
                                            <p>Need help? We're here for you! Reach out anytime for support—we’re committed to your success and a smooth experience with StoneSkill.</p>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="row">
                                                <div className="col-lg-6 mb-4">
                                                    <h5 className="mb-20">01. Visit Feedback</h5>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                                </div>
                                                <div className="col-lg-6 mb-4">
                                                    <h5 className="mb-20">02. Employer Services</h5>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                                </div>
                                                <div className="col-lg-6 mb-lg-0 mb-4">
                                                    <h5 className="mb-20 text-brand">03. Billing Inquiries</h5>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                                </div>
                                                <div className="col-lg-6">
                                                    <h5 className="mb-20">04.General Inquiries</h5>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <section className="container-fluid mb-50">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3735.994305473526!2d75.74400059999999!3d20.5474139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd98153022c84c7%3A0x6e603822b99939c0!2sStoneskill!5e0!3m2!1sen!2sin!4v1735929250069!5m2!1sen!2sin" width={100 + '%'} height={400} style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                        </section>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-10 col-lg-12 m-auto">
                                    <section className="mb-50">
                                        <div className="row mb-60">
                                            <div className="col-md-4">
                                                <h4 className="mb-15 text-brand">Shop</h4>
                                                Aurangabad Jalgaon Highway Behind Hotel Pawan & lodging Ajanta
                                                Pincode:-431117 <br />
                                                <abbr title="Phone">Phone:</abbr> +91 9049045886<br />
                                                <abbr title="Email">Email: </abbr>stoneskill07@gmail.com<br />
                                                <a className="btn btn-sm font-weight-bold text-white mt-20 border-radius-5 btn-shadow-brand hover-up"><i className="fi-rs-marker mr-5" />View map</a>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-8">
                                                <div className="contact-from-area padding-20-row-col">
                                                    <h5 className="text-brand mb-10">Contact form</h5>
                                                    <h2 className="mb-10">Drop Us a Line</h2>
                                                    <p className="text-muted mb-30 font-sm">Your email address will not be published. Required fields are marked *</p>
                                                    <form className="contact-form-style mt-30" onSubmit={handleSubmit}>
                                                        <div className="row">
                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-style mb-20">
                                                                    <input
                                                                        name="name"
                                                                        placeholder="First Name*"
                                                                        type="text"
                                                                        value={formData.name}
                                                                        onChange={handleChange}
                                                                    />
                                                                    {errors.name && <div className="text-danger">{errors.name}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-style mb-20">
                                                                    <input
                                                                        name="email"
                                                                        placeholder="Your Email*"
                                                                        type="email"
                                                                        value={formData.email}
                                                                        onChange={handleChange}
                                                                    />
                                                                    {errors.email && <div className="text-danger">{errors.email}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-style mb-20">
                                                                    <input
                                                                        name="telephone"
                                                                        placeholder="Your Phone*"
                                                                        type="number"
                                                                        value={formData.telephone}
                                                                        onChange={handleChange}
                                                                        maxLength="10"
                                                                    />
                                                                    {errors.telephone && <div className="text-danger">{errors.telephone}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-style mb-20">
                                                                    <input
                                                                        name="subject"
                                                                        placeholder="Subject*"
                                                                        type="text"
                                                                        value={formData.subject}
                                                                        onChange={handleChange}
                                                                    />
                                                                    {errors.subject && <div className="text-danger">{errors.subject}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="textarea-style mb-30">
                                                                    <textarea
                                                                        name="message"
                                                                        placeholder="Message*"
                                                                        value={formData.message}
                                                                        onChange={handleChange}
                                                                    />
                                                                    {errors.message && <div className="text-danger">{errors.message}</div>}
                                                                </div>
                                                                <button type="submit" className="submit submit-auto-width">
                                                                    Send message
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                    <p className="form-messege" />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 pl-50 d-lg-block d-none">
                                                <img className="border-radius-15 mt-50" src="assets/imgs/page/contact-2.png" alt />
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Contact;